import React from 'react';
import { List } from 'antd';
import SummaryCard from './SummaryCard';
import CommentItem from '@/components/ProjectDetails/Cards/Items/CommentItem';
import { F } from '@/utils/intl';

export interface CommentsCardProps {
  comments: any[];
  count: number;
  onAdd?: () => void;
  onShowAll?: () => void;
}

const CommentsCard: React.FC<CommentsCardProps> = ({
  comments,
  count,
  onAdd,
  onShowAll,
}) => {
  return (
    <SummaryCard
      title={<F id={'entity.comment.plural'} defaultMessage={'Comments'} />}
      count={count}
      onAdd={onAdd}
      onShowAll={onShowAll}
    >
      <List
        dataSource={comments}
        renderItem={(comment) => (
          <CommentItem openCommentsDrawer={onShowAll} comment={comment} />
        )}
      />
    </SummaryCard>
  );
};

export default CommentsCard;
